import {  HomogenizationOrder } from "../sdk";

export class IHomogenizationOrder extends HomogenizationOrder {

    public isSelected:boolean = false;

    public static readonly IMODEL = "homogenization.order";

    public static readonly FILTER_DEFAULT = "processing";

    public static readonly FIELDS: Array<string> = [
        'id',
        'name',
        'warehouse_location_id',
        'partner_id',
        'product_id',
        'in_line_ids',
        'in_move_ids',
        'out_line_ids',
        'out_move_ids',
        'location_id',
        'location_dest_id',
        'no_quality_location_id',
        'production_location_id',
        'date_planned_start',
        'date_done',
        'state',
        'user_id',
        'company_id',
        'analysis_ids',
        'quality_analysis_parent_id'
    ];
    public static readonly FILTER_INCLUDE:any = [
        {
            "relation": "partner",
            "scope": {"fields": ["id", "name"]}
        },
        {
            "relation": "warehouseLocation",
            "scope": {"fields": ["id", "name"]}
        },
        {
            "relation": "product",
            "scope": {"fields": ["id", "name", "display_name"]}
        },
        {
            "relation": "inLines",
            "scope": {
                "fields": ["id", "name", "product_id", "location_id", "location_dest_id", "package_id", "prod_lot_id", "product_qty", "product_uom_id", "state"],
                "include": [
                    {
                        "relation": "product",
                        "scope": {"fields": ["id", "name"]}
                    },
                    {
                        "relation": "location",
                        "scope": {"fields": ["id", "name"]}
                    },
                    {
                        "relation": "locationDest",
                        "scope": {"fields": ["id", "name"]}
                    },
                    {
                        "relation": "package",
                        "scope": {"fields": ["id", "name"]}
                    },
                    {
                        "relation": "prodLot",
                        "scope": {"fields": ["id", "name"]}
                    },
                    {
                        "relation": "productUom",
                        "scope": {"fields": ["id", "name"]}
                    }
                ]
            }
        },
        {
            "relation": "inMoves",
            "scope": {"fields": ["id", "name"]}
        },
        {
            "relation": "outLines",
            "scope": {
                "fields": ["id", "name", "product_id", "location_id", "location_dest_id", "package_id", "prod_lot_id", "product_qty", "product_uom_id", "state"],
                "include": [
                    {
                        "relation": "product",
                        "scope": {"fields": ["id", "name"]}
                    },
                    {
                        "relation": "location",
                        "scope": {"fields": ["id", "name"]}
                    },
                    {
                        "relation": "locationDest",
                        "scope": {"fields": ["id", "name"]}
                    },
                    {
                        "relation": "package",
                        "scope": {"fields": ["id", "name"]}
                    },
                    {
                        "relation": "prodLot",
                        "scope": {"fields": ["id", "name"]}
                    },
                    {
                        "relation": "productUom",
                        "scope": {"fields": ["id", "name"]}
                    }
                ]
            }
        },
        {
            "relation": "outMoves",
            "scope": {"fields": ["id", "name"]}
        },
        {
            "relation": "location",
            "scope": {"fields": ["id", "name"]}
        },
        {
            "relation": "locationDest",
            "scope": {"fields": ["id", "name"]}
        },
        {
            "relation": "noQualityLocation",
            "scope": {"fields": ["id", "name"]}
        },
        {
            "relation": "productionLocation",
            "scope": {"fields": ["id", "name"]}
        },
        {
            "relation": "user",
            "scope": {"fields": ["id", "name"]}
        },
        {
            "relation": "company",
            "scope": {"fields": ["id", "name"]}
        },
        {
            "relation": "analysis",
            "scope": {"fields": ["id", "name"]}
        },
        {
            "relation": "qualityAnalysisParent",
            "scope": {"fields": ["id", "name"]}
        }
    ]

    public uom: {id: number, name:string};

    constructor(json: HomogenizationOrder) {
        super(json);
    }
}


// WEBPACK FOOTER //
// ./src/models/IHomogenizationOrder.ts